import { useState, useCallback } from 'react';

const useApi = (apiFunc) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (...args) => {
    setLoading(true);
    try {
      const result = await apiFunc(...args);
      setError(null);
      setData(result.data);
      setStatus(result.status);
      return result;
    } catch (err) {
      setError(err.message);
      setStatus(err.status || 500);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [apiFunc]);

  return {
    data,
    error,
    status,
    loading,
    request,
  };
};

export default useApi;
